export const salaryRoutes = [
  {
    path: '/salary-period',
    component: () => import('@/views/salary/PeriodList.vue'),
    name: 'SalaryPeriodList',
    meta: {
      title: 'Kỳ lương',
      auth: true
    }
  },
  {
    path: '/salary-period/:id',
    component: () => import('@/views/salary/PeriodDetail.vue'),
    name: 'SalaryPeriodDetail',
    meta: {
      title: 'Chi tiết kỳ lương',
      auth: true
    }
  },
  {
    path: '/salary-group',
    component: () => import('@/views/salary/GroupList.vue'),
    name: 'SalaryGroupList',
    meta: {
      title: 'Nhóm đối tượng áp dụng lương',
      auth: true
    }
  },
  {
    path: '/salary-group/:id',
    component: () => import('@/views/salary/GroupDetail.vue'),
    name: 'SalaryGroupDetail',
    meta: {
      title: 'Chi tiết nhóm đối tượng áp dụng lương',
      auth: true
    }
  },
  {
    path: '/salary-head/:category',
    component: () => import('@/views/salary/HeadList.vue'),
    name: 'salary-head/',
    meta: {
      title: '',
      auth: true
    }
  },
  {
    path: '/salary-head/:category/:id',
    component: () => import('@/views/salary/HeadDetail.vue'),
    name: 'salary-head/',
    meta: {
      title: 'Chi tiết ',
      auth: true
    }
  },
  {
    path: '/salary-collection',
    component: () => import('@/views/salary/CollectionList.vue'),
    name: 'CollectionList',
    meta: {
      title: 'Nhóm khoản lương',
      auth: true
    }
  }
]
